import {JsonObject} from "../../shared/json/json-object";

@JsonObject()
export abstract class GameData {
}

@JsonObject()
export abstract class GameSettings {

}